/* Shopify layout integration only. Original LP motion stays in sfg-lp.js unchanged. */
(() => {
  if (!document.body.classList.contains('sfg-lp')) return;
  const header = document.querySelector('.page-header');
  const measure = () => document.body.style.setProperty('--sfg-lp-header-height', `${Math.ceil(header?.getBoundingClientRect().height || 110)}px`);
  if (header && 'ResizeObserver' in window) new ResizeObserver(measure).observe(header);
  window.addEventListener('resize', measure, { passive: true });
  measure();
  if (!('IntersectionObserver' in window)) return;
  const visible = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
    document.body.classList.toggle('sfg-lp-offer-visible', visible.size > 0);
  }, { threshold: .05 });
  document.querySelectorAll('.sfg-lp-section #offer, .sfg-lp-section #offer2').forEach(el => observer.observe(el));
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('#offer, #offer2').forEach(el => observer.observe(el));
  });
})();
